import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './hometestimonials.css';

const testimonialsData = [
  {
    text: "As a Celestial Explorer member, I look forward to my personalized monthly horoscopes and the early access.",
    name: "Sarah M.",
    role: "Celestial Member",
  },
  {
    text: "I love the curated content — it helps me plan my month with intention and insight.",
    name: "Amir K.",
    role: "Member",
  },
  {
    text: "The monthly forecasts are clear and beautifully explained. Highly recommend.",
    name: "Lina P.",
    role: "Subscriber",
  },
];

export default function TestimonialSlider({ autoPlayMs = 4500 }) {
  return (
    <section className="testimonial-slider-testimonials" aria-roledescription="carousel" aria-label="Testimonials">
      <div className="ts-inner-testimonials">
        <div className="ts-label-testimonials">TESTIMONIAL</div>
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          autoplay={{ delay: autoPlayMs, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          navigation
          loop
          spaceBetween={20}
          slidesPerView={1}
          className="ts-slides-testimonials"
        >
          {testimonialsData.map((t, i) => (
            <SwiperSlide key={i} className="ts-slide-testimonials">
              <h2 className="ts-quote-testimonials">{t.text}</h2>
              <div className="ts-author-testimonials">
                <span className="ts-name-testimonials">{t.name}</span>
                <span className="ts-sep-testimonials"> - </span>
                <span className="ts-role-testimonials">{t.role}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
